import * as React from 'react';
import styles from './index.less';
import { FI18n } from '@freelog/tools-lib';

interface FContractStatusBadgeProps {
  status: 'active' | 'testActive' | 'inactive' | 'terminal';
}

// const statusTextObj = ;

function FContractStatusBadge({ status }: FContractStatusBadgeProps) {
  const ref_statusTextObj = React.useRef({
    // active: '已授权',
    active: FI18n.i18nNext.tAuto('contract_state_authorized'),
    // testActive: '测试授权',
    testActive: FI18n.i18nNext.tAuto('contract_state_testauthorized'),
    // inactive: '未授权',
    inactive: FI18n.i18nNext.tAuto('contract_state_unauthorized'),
    // terminal: '已终止',
    terminal: FI18n.i18nNext.tAuto('contract_state_end'),
  } as const);
  return (
    <label className={[styles.style, styles[status]].join(' ')}>
      {ref_statusTextObj.current[status]}
    </label>
  );
}

export default FContractStatusBadge;
